(function () {
    'use strict';

    function integerSearchField() {
        return {
            restrict: 'E',
            scope: {
                attribute: '=',
                changeEvent: '&'
            },
            templateUrl: 'common/directives/templates/integerSearchField.html',
            link: function (scope, element, attrs) {
                scope.hasChangeEvent = attrs.changeEvent;
            }
        };
    }

    integerSearchField.$inject = [];

    angular.module('ecap.common').directive('integerSearchField', integerSearchField);
})();